import PricingTrialButton from './PricingTrialButton'

export default PricingTrialButton
